import { signOut } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import { unregisterPushNotifications } from '@/lib/pushNotifications';

export async function signOutUser(): Promise<void> {
  await unregisterPushNotifications();
  await signOut(auth);
}
